(function () {
    'use strict';
    // Directives used to organize our sidebar

    angular.module('GorillaBoy.directives')

    .directive('rightPanelWidget', ['SourceConstant', function(SourceConstant) {

            var controllerFunction = function(rootscope, scope, location){
                 console.log("Entered Right Panel Widget Controller");
            };

          return {
                restrict: 'E',
                templateUrl: './right-panel/right_panel_widget.html',
                scope : true,
                controller : ['$rootScope', '$scope', '$location', controllerFunction]
          };
      }])

    .directive('right', [
        '$location',
        '$timeout',
        '$log',
        '$q',
        '$translate',
        '$rootScope',
        'focus',
        'SignalProvider',
        'SourceConstant',
        'AppConstants',
        'DocumentStateService',
        'ApprovalDetailsService',
        function ($location, $timeout, $log, $q, $translate, $rootScope, focus, SignalProvider, SourceConstant, AppConstants, DocumentStateService, ApprovalDetailsService) {
        return {
            restrict: 'E',
            replace: false,
            link: function (scope, element, attrs) {
                var DELAYED_TRANSITION = 300,

                    // AppConstant bindings
                    rightTabTypes = AppConstants.RightTabTypes,
                    layoutViewTypes = AppConstants.LayoutViewTypes;

                var constructTab = function (name, index, icon) {
                    return {
                        name: name,
                        index: index,
                        icon:    icon
                    };
                };

                scope.getRightPanelHeader = function() {
                    var key = null;
                    if (scope.sidebar.tabName === AppConstants.RightTabTypes.NEW_APPROVAL_REQUEST_TAB &&
                        ApprovalDetailsService.getServiceMode() == 'EDIT') {
                        key = 'RIGHT_NAV.NEW_APPROVAL_REQUEST_NAME_EDITING_MODE';
                    } else if (!!scope.sidebar.tabName) {
                        key = scope.RIGHT_TABS[scope.sidebar.tabName].name;
                    }
                    return $translate.instant(key);
                };

                scope.rightPanelView = {
                    forceShowingOverallComment : false,
                    forceHidingDraftPublishingComponent : true
                };

                scope.getTabcontainerClassName = function(tabName) {
                    if (tabName !== 'Feedback' || !scope.showDraftPublishingComponent() || scope.layout.showFilterPanel) {
                        //I don't care about these scenarios
                        return '';
                    }
                    if (!scope.rightPanelView.forceHidingDraftPublishingComponent) {
                        return 'with-send-drafts-button-and-text-comp';
                    }
                    return 'with-send-drafts-button';
                };

                scope.showDraftPublishingComponent = function() {
                    return (scope.allowFeedback() || scope.documentState.activeVersion.VersionStatus === AppConstants.DOCUMENT_VERSION_STATUS.DRAFT) && !scope.documentFormData.disableFeedback && scope.documentState.pendingFeedbackCountForAllVersions;
                };

                scope.LayoutViewTypes = layoutViewTypes;

                var tabIndex = 0;
                if (scope.layout.view === AppConstants.LayoutViewTypes.APPROVALS_VIEW) {
                    scope.RIGHT_TABS = {
                        ApprovalsPeople: constructTab('RIGHT_NAV.APPROVALS.PEOPLE', tabIndex++, 'icon-group'),
                        ApprovalsFiles: constructTab('RIGHT_NAV.APPROVALS.FILES', tabIndex++, 'icon-comments'),
                        ApprovalsComments: constructTab('RIGHT_NAV.APPROVALS.COMMENTS', tabIndex++, 'icon-cog'),
                    };
                } else {
                    scope.RIGHT_TABS = {
                        People: constructTab('RIGHT_NAV.PERMISSIONS', tabIndex++, 'icon-group'),
                        Feedback: constructTab('RIGHT_NAV.FEEDBACK', tabIndex++, 'icon-comments'),
                        Security: constructTab('RIGHT_NAV.FILE_INFO', tabIndex++, 'icon-cog'),
                        View: constructTab('RIGHT_NAV.VIEW', tabIndex++, 'icon-file')
                    };
                }

                //approval panel is only applicable for certain views
                if (scope.viewSupportsNewApprovals(scope.layout.view)) {
                    scope.RIGHT_TABS.NewApprovalRequest = constructTab('RIGHT_NAV.NEW_APPROVAL_REQUEST_NAME', 1, 'icon-comments');
                }

                scope.useTransition = function() {
                    return scope.layout.view !== AppConstants.LayoutViewTypes.VIEW_DOCUMENT_LAYOUT;
                };

                var handleGetParams = function () {
                    var getParams = $location.search();
                    if (getParams.show) {
                        if (scope.sidebar.tabs.indexOf(getParams.show) === -1) {
                            setRightTab(rightTabTypes.PEOPLE_TAB);
                        } else {
                            setRightTab(getParams.show, true);
                        }
                        $timeout(function() {
                            scope.layout.showRightSidebar = true;
                        }, 0);
                    }
                };

                scope.layout.rightPanelWidth = 400;
                var setRightTab = function (tabName) {
                    // Utility function to change right tabs.
                    // Delay for transition parameter should be set to true when we do a slide or fade in.
                    var done = $q.defer();

                    scope.sidebar.tabName = tabName;
                    scope.sidebar.selectedIndex = scope.RIGHT_TABS[tabName].index;

                    $timeout(function () {
                        $('.tabcontainer').css('margin-left', (scope.sidebar.selectedIndex) * (-scope.layout.rightPanelWidth) + 'px');

                        if (tabName === rightTabTypes.FEEDBACK_TAB) {
                            DocumentStateService.feedback.selectedFeedback = null;
                            scope.documentState.showCompressedFeedbackFilter = false;

                            if(scope.documentState.feedbackLoaded){
                                $timeout(function (){
                                    $rootScope.$broadcast(SignalProvider.FeedbackDrawn.AllFeedbackRendered);
                                }, 0, false);
                            }
                            // Remove input component if there is any
                            $rootScope.$broadcast(SignalProvider.FeedbackInput.Clear);
                            $timeout(function () {
                                enableRendering();
                            });
                        } else {
                            if (scope.sidebar.tabName === rightTabTypes.PEOPLE_TAB) {
                                $timeout(function () {
                                    disableRendering();
                                });
                                clearExpandingGroup();
                            }
                        }
                        done.resolve();
                    }, 0);

                    return done.promise;
                };

                var clearExpandingGroup = function () {
                    $rootScope.$broadcast(SignalProvider.Group.ClearExpandingGroup);
                };

                var enableRendering = function () {
                    if (scope.documentState && scope.documentState.documentViewerBridge) {
                        scope.documentState.documentViewerBridge.showAnnotations();
                    }
                };

                var disableRendering = function () {
                    if (scope.documentState && scope.documentState.documentViewerBridge) {
                        scope.documentState.documentViewerBridge.hideAnnotations();
                    }
                };

                /***
                    Initialization and set watchers
                ***/

                handleGetParams();

                scope.$on(SignalProvider.Sidebar.ChangeRight, function (scope, tabName) {
                    // Changes right tab through flick
                    setRightTab(tabName);
                });

                scope.$on(SignalProvider.Sidebar.SlideRight, function (scope, tabName) {
                    // Changes right tab through sliding
                    $('.tabcontainer').addClass('sidebar-transition');
                    setRightTab(tabName, true).then(function (){
                        $timeout(function () {
                            $('.tabcontainer').removeClass('sidebar-transition');
                            $timeout(function (){
                                focus('feedbackInput');
                            }, DELAYED_TRANSITION);
                        }, DELAYED_TRANSITION);
                    });
                });

                scope.$on(SignalProvider.Sidebar.ToggleRight, function (event, tabName) {
                    scope.layout.showRightSidebar = !scope.layout.showRightSidebar;
                    if (tabName !== undefined && scope.layout.showRightSidebar) {
                        scope.sidebar.tabName = tabName;
                        if (tabName === AppConstants.RightTabTypes.NEW_APPROVAL_REQUEST_TAB) {
                            ApprovalDetailsService.setPanelVisibility(true);
                        }
                    }
                    if (!scope.layout.showRightSidebar) {
                        if (scope.sidebar.tabName === AppConstants.RightTabTypes.NEW_APPROVAL_REQUEST_TAB) {
                            ApprovalDetailsService.setPanelVisibility(false);
                            // init without parameter effectively clear the store
                            ApprovalDetailsService.initService();
                        }
                        scope.sidebar.tabName = null;
                        
                        disableRendering();
                    }
                });

                scope.$on(SignalProvider.Sidebar.ShowRight, function (event, tabName) {
                    scope.layout.showRightSidebar = true;
                    if (tabName !== undefined && scope.layout.showRightSidebar) {
                        scope.sidebar.tabName = tabName;
                        if (tabName === AppConstants.RightTabTypes.NEW_APPROVAL_REQUEST_TAB) {
                            ApprovalDetailsService.setPanelVisibility(true);
                        }
                    }
                });

                scope.$on(SignalProvider.Sidebar.HideAnnotationArrow, function(){
                    disableRendering();
                });

                scope.$watch('sidebar', function (newVal, oldVal) {
                    if (!newVal || !newVal.tabName) {
                        return;
                    }
                    // Changes right tab upon initialization
                    setRightTab(scope.sidebar.tabName);
                }, true);

                scope.$watch('documentState.feedbackLoaded', function(newVal, oldVal) {
                    if (newVal === oldVal || !newVal) {
                        return;
                    }

                    if(scope.sidebar.tabName === rightTabTypes.FEEDBACK_TAB){
                        $timeout(function (){
                            $rootScope.$broadcast(SignalProvider.FeedbackDrawn.AllFeedbackRendered);
                        }, 0, false);
                    }
                });

                scope.$on(SignalProvider.Sidebar.FocusFeedbackInput, function () {
                    $timeout(function (){
                        focus('feedbackInput');
                    }, 0);
                });
            },
            templateUrl: './right-panel/right_panel.html'
        };
    }]);
}());
